/* eslint-disable react-hooks/exhaustive-deps */
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { RouteGuard } from "~/components/RouteGuard";
import { useEffect, useState } from "react";
import { useModals } from "~/router";
import { ArrowBigLeft } from "lucide-react";

export default function Layout() {

    /* Le hook permettant de changer le header et le title de la page */
    const [pageTitle, setPageTitle] = useState('Sans nom')

    const location = useLocation()
    const navigate = useNavigate()
    const [showBackButton, setShowBackButton] = useState(false)
    const [showTitle, setShowTitle] = useState(true)

    /* Le hook permettant de connaitre l'etat des modals (open par exemple) */
    const modals = useModals()

    /* Lorsque l'on met à jour le titre, on change aussi le document.title */
    useEffect(() => {
        document.title = pageTitle
    }, [pageTitle])

    useEffect(() => {
        if(showBackButton && !location.state?.from) {
            setShowBackButton(false)
        }
    }, [showBackButton])

    const backHandler = () => {
        if(location.state?.from) {
            navigate(location.state.from)
            setShowBackButton(false)
        }
    }

    return (
        <RouteGuard>
            {/* Le route guard permet de vérifier que l'utilisateur est authentifié */}
            { showTitle && <header className="">
                <div className="mx-2 lg:mx-8 mt-6 flex gap-4 items-center">
                    { showBackButton && <button onClick={backHandler}><ArrowBigLeft size={32} className="text-primary hover:text-blue-900" /></button> }
                    <h1 className="text-3xl font-bold tracking-tight text-blue-900">{pageTitle}</h1>
                </div>
            </header> }
            <main>
                {/* Le blur permet de flouter le fond lorsque la modal est ouverte */}
                <div className={`mx-2 max-w-9xl my-6 sm:mx-6 lg:mx-8 ${modals.current != '' ? 'blur' : ''}`}>
                    {/* Le context à la outlet permet de changer le titre */}
                    <Outlet context={[pageTitle, setPageTitle, showBackButton, setShowBackButton, showTitle, setShowTitle]} />
                </div>
            </main>
        </RouteGuard>
    )
}